"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.Units = exports.UniformDistributionButton = exports.ThresholdsDisclaimer = exports.ThresholdButtonWrapper = exports.ThresholdButtonsWrapper = exports.ThresholdButtonsMobileWrapper = exports.ThresholdButton = exports.StyledContainer = exports.StaticMobileSliderContainer = exports.SliderContainer = exports.RangeInput = exports.PlaceholderButton = exports.OldStyleSliderText = exports.OldStyleSliderHandles = exports.OldStyleSliderHandle = exports.NumberInput = exports.InputContainer = exports.ErrorMessage = exports.DesktopContainer = exports.ColorBoxNumberInput = exports.ColorBox = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors = __importStar(require("../../../assets/styles/colors"));
const media_1 = require("../../../utils/media");
const Button_style_1 = require("../../atoms/Button/Button.style");
const ThresholdButton_1 = require("./ThresholdButtons/ThresholdButton");
const SliderContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;

  ${(props) => props.$isMobileOldStyle &&
    `
    padding: 0 0.5rem;
  `}
`;
exports.SliderContainer = SliderContainer;
const ColorBox = styled_components_1.default.div `
  width: 100%;
  height: 2.4rem;
  display: inline-block;
  border-radius: 0.5rem;
`;
exports.ColorBox = ColorBox;
const StaticMobileSliderContainer = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(4, auto 1fr) auto;
  grid-template-rows: auto;
  gap: 0.9rem;
  align-items: center;
  width: 100%;
`;
exports.StaticMobileSliderContainer = StaticMobileSliderContainer;
const InputContainer = styled_components_1.default.div `
  position: relative;
  width: 100%;
  padding-left: 1.5rem;
  justify-content: space-between;

  ${(props) => props.$useColorBoxStyle &&
    `
    height: 4.7rem;
    padding-left: 0;
  `}

  @media (${media_1.media.mobile}) {
    ${(props) => props.$isMobileOldStyle &&
    `
    height: 4.7rem;
  `}
  }

  @media (${media_1.media.desktop}) {
    padding-left: 0;
    height: 30px;
    margin-bottom: 0;
  }
`;
exports.InputContainer = InputContainer;
const ThresholdButton = (0, styled_components_1.default)(Button_style_1.Button) `
  white-space: nowrap;
  background: ${colors.gray100};
  border: none;
  color: ${colors.gray300};
  width: 100%;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
  align-content: center;

  @media ${media_1.media.desktop} {
    margin-left: 0;
    ${(props) => props.$variant === ThresholdButton_1.ThresholdButtonVariant.IconOnly &&
    `
        height: 3.2rem;
        min-width: 5.2rem;
      `}
  }

  @media ${media_1.media.smallDesktop} {
    margin-left: 0;
    ${(props) => props.$variant === ThresholdButton_1.ThresholdButtonVariant.IconOnly &&
    `
        height: 3.2rem;
        min-width: 5.2rem;
      `}
  }

  @media ${media_1.media.mobile} {
    margin-left: auto;
    white-space: pre-line;
    text-align: left;
    line-height: 1.6rem;
    width: 100%;
    min-width: 5rem;
    padding: 0.6rem 1.2rem;
    font-size: 1.2rem;
  }
`;
exports.ThresholdButton = ThresholdButton;
const PlaceholderButton = (0, styled_components_1.default)(Button_style_1.Button) `
  background: transparent;
  border: none;
  width: 100%;
  height: 3.2rem;
  min-width: 5.2rem;

  @media ${media_1.media.smallDesktop} {
    display: none;
  }

  @media ${media_1.media.mobile} {
    width: 100%;
    min-width: 100px;
  }
`;
exports.PlaceholderButton = PlaceholderButton;
const ThresholdButtonWrapper = styled_components_1.default.div `
  display: grid;
  gap: 10px;
  align-items: center;
  grid-template-columns: auto 1fr;

  @media ${media_1.media.mobile} {
    grid-template-columns: 1fr auto;
    max-width: 100px;
    gap: 10px;
  }
`;
exports.ThresholdButtonWrapper = ThresholdButtonWrapper;
const ThresholdButtonsWrapper = styled_components_1.default.div `
  display: flex;
  gap: 1.6rem;
  justify-content: center;
  width: fit-content;

  @media ${media_1.media.tabletMax} {
    display: none;
  }
  @media ${media_1.media.desktop} {
    display: flex;
  }
`;
exports.ThresholdButtonsWrapper = ThresholdButtonsWrapper;
const ThresholdButtonsMobileWrapper = styled_components_1.default.div `
  display: grid;
  gap: 1rem;
  justify-content: center;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);

  @media ${media_1.media.desktop} {
    display: none;
  }
`;
exports.ThresholdButtonsMobileWrapper = ThresholdButtonsMobileWrapper;
const UniformDistributionButton = (0, styled_components_1.default)(Button_style_1.Button) `
  white-space: nowrap;
  background: ${colors.gray100};
  border: none;
  color: ${colors.gray300};
  width: 5.2rem;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
  align-content: center;

  @media ${media_1.media.desktop} {
    margin-left: 0;
    height: 32px;
  }

  @media ${media_1.media.smallDesktop} {
    margin-left: 0;

    height: 32px;
  }

  @media ${media_1.media.mobile} {
    display: none;
  }
`;
exports.UniformDistributionButton = UniformDistributionButton;
const ThresholdsDisclaimer = styled_components_1.default.h3 `
  font-size: 1.2rem;
  font-weight: 600;
  color: ${colors.gray300};
  width: 9.3rem;
  padding: 0rem 0.5rem;
  text-align: right;
  /* compensate for the margin on first threshold thumb */
  margin-right: 1.5rem;
`;
exports.ThresholdsDisclaimer = ThresholdsDisclaimer;
const DesktopContainer = styled_components_1.default.div `
  display: grid;
  gap: 1rem;
  align-items: center;

  @media ${media_1.media.desktop} {
    grid-template-columns: auto 1fr auto auto;
    grid-template-rows: auto;
    gap: 1rem;
  }

  @media ${media_1.media.mobile} {
    grid-template-columns: auto;
  }
`;
exports.DesktopContainer = DesktopContainer;
const RangeInput = styled_components_1.default.input `
  width: 100%;
  position: absolute;
  top: 50%;
  margin-left: -15px;
  transform: translateY(-50%);
  height: 9px;
  overflow: hidden;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  caret-color: transparent;
  background: linear-gradient(
    to right,
    ${colors.green100} ${(props) => props.$firstThumbPos}px,
    ${colors.yellow100} ${(props) => props.$firstThumbPos}px,
    ${colors.yellow100} ${(props) => props.$secondThumbPos}px,
    ${colors.orange100} ${(props) => props.$secondThumbPos}px,
    ${colors.orange100} ${(props) => props.$thirdThumbPos}px,
    ${colors.red100} ${(props) => props.$thirdThumbPos}px,
    ${colors.red100} 100%
  );
  border-radius: 2px;
  outline: none;
  opacity: 0.7;
  transition: opacity 0.2s;
  color: transparent;
  border: none;

  &::-webkit-slider-thumb,
  &::-moz-range-thumb,
  &::-ms-thumb {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 0;
    height: 0;
    background: transparent; /* Set the background to transparent */
    border: none;
  }

  &::-ms-track {
    width: 0;
    cursor: pointer;

    background: transparent;
    border-color: transparent;
    color: transparent;
  }

  &::-webkit-slider-thumb:hover,
  &::-moz-range-thumb:hover,
  &::-ms-thumb:hover {
    background: ${colors.gray300};
    border-color: ${colors.gray300};
  }

  &::-webkit-slider-runnable-track {
    display: none;
    width: 0;
    height: 0;
    cursor: pointer;
    background: transparent;
    border: none;
    color: transparent;
    border-radius: 0px;
  }

  &::-moz-range-track {
    display: none;
    width: 0px;
    height: 0px;
    cursor: pointer;
    background: transparent;
    border: none;
    color: transparent;
    border-radius: 0px;
  }

  ::-ms-track {
    display: none;
    width: 0%;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
    border-width: 0px;
  }

  &:focus::-webkit-slider-runnable-track {
    background: transparent;
    border: none;
    color: transparent;
  }

  &:focus::-moz-range-track {
    background: transparent;
    border: none;
    color: transparent;
  }

  &:focus {
    outline: none;
    background: transparent;
    height: 0;
    color: transparent;
    caret-color: transparent;
  }

  &::-webkit-slider-thumb:active,
  &::-moz-range-thumb:active,
  &::-ms-thumb:active {
    background: ${colors.white};
    border-color: ${colors.gray300};
    color: transparent;
  }

  &::-moz-focus-outer {
    border: 0;
  }

  @media (${media_1.media.desktop}) {
    margin-left: 0;
  }

  ${(props) => props.$isMobileOldStyle &&
    `
    height: 3px;
    top: 60%; /* Move the range input down */
    transform: translateY(-50%);
    color: transparent;
  `}
`;
exports.RangeInput = RangeInput;
const ColorBoxNumberInput = styled_components_1.default.input `
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  min-width: 2.4rem;
  max-width: 2.9rem;
  height: 5rem;
  justify-content: space-between;
  text-align: center;
  border-radius: 5px;
  border: 1px solid ${colors.darkBlueTransparent};
  z-index: 7;
  font-size: 1.6rem;
  color: ${colors.darkBlue};

  @media (${media_1.media.mobile}) {
    height: 4.7rem;
  }

  @media (${media_1.media.desktop}) {
    padding-left: 0;
    height: 30px;
    margin-bottom: 0;
  }

  appearance: textfield;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    border: 1px solid ${colors.acBlue};
    outline: 0px solid ${colors.acBlue};
    background-color: ${colors.acBlueTransparent};
    color: ${colors.gray400};
    font-weight: 600;
  }
`;
exports.ColorBoxNumberInput = ColorBoxNumberInput;
const NumberInput = styled_components_1.default.input `
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  color: ${colors.gray300};
  position: absolute;
  top: 10px;
  right: ${(props) => (props.$isLast ? "0px" : "auto")};
  max-width: 30px;
  height: 50px;
  margin-left: -15px;
  border-radius: 5px;
  border: 1px solid ${colors.gray100};
  box-shadow: 2px 2px 4px 0px rgba(76, 86, 96, 0.1);
  z-index: 7;
  cursor: ${(props) => props.$isMin || props.$isLast
    ? "default"
    : "move"}; /* fallback if grab cursor is unsupported */
  cursor: ${(props) => (props.$isMin || props.$isLast ? "default" : "grab")};

  appearance: textfield;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:active {
    cursor: ${(props) => props.$isMin || props.$isLast ? "default" : "grabbing"};
    cursor: ${(props) => props.$isMin || props.$isLast ? "default" : "-moz-grabbing"};
    cursor: ${(props) => props.$isMin || props.$isLast ? "default" : "-webkit-grabbing"};
  }
  &:disabled {
    background-color: ${colors.white};
  }

  &:focus-visible {
    border-color: ${(props) => props.$isActive
    ? "transparent"
    : props.$hasError
        ? colors.red100
        : colors.gray100};
    outline: 2px solid
      ${(props) => (props.$isActive ? colors.gray100 : "transparent")};
  }

  @media ${media_1.media.desktop} {
    font-weight: 600;
    font-size: 1.5rem;
    max-width: 40px;
    height: 32px;
    top: -1px;
  }
`;
exports.NumberInput = NumberInput;
const ErrorMessage = styled_components_1.default.p `
  color: ${colors.red100};
  position: absolute;
  background-color: ${colors.white};
  top: 8%;
  left: 50%;
  transform: translate(-50%, -40%);
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  z-index: 20;

  @media ${media_1.media.smallDesktop} {
    font-size: 1.5rem;
    transform: translate(-50%, -50%);
    top: 30%;
  }
`;
exports.ErrorMessage = ErrorMessage;
const Units = styled_components_1.default.sup `
  font-size: 1.2rem;
  vertical-align: super;
  position: relative;
  font-weight: 400;
  line-height: 1.6;
  color: ${colors.gray400};
  left: 2rem;
`;
exports.Units = Units;
const StyledContainer = styled_components_1.default.div `
  display: inline;
`;
exports.StyledContainer = StyledContainer;
const Wrapper = styled_components_1.default.div `
  display: flex;
  gap: 1rem;
`;
exports.Wrapper = Wrapper;
const OldStyleSliderHandles = styled_components_1.default.div `
  position: absolute;
  top: 60%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  z-index: 10;
  user-select: none;
`;
exports.OldStyleSliderHandles = OldStyleSliderHandles;
const OldStyleSliderHandle = styled_components_1.default.div `
  width: 13px;
  height: 13px;
  background-color: ${colors.white};
  box-shadow: rgba(166, 166, 166, 0.5) 0px 2px 4px;

  border-radius: 50%;
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: none;
  &:active {
    cursor: grabbing;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
  }
`;
exports.OldStyleSliderHandle = OldStyleSliderHandle;
const OldStyleSliderText = styled_components_1.default.p `
  font-size: 1.2rem;
  font-weight: 600;
  color: ${colors.gray400};
  position: absolute;
  top: -16px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
exports.OldStyleSliderText = OldStyleSliderText;
